import PropTypes from "prop-types"
import React from "react"
import {useHeader} from "@utils"

// Components
import HeaderBlank from "./HeaderBlank"
import HeaderTransparent from "./HeaderTransparent"
import HeaderDefault from "./HeaderDefault"

function Header({navitems, transparent, blankHeader}) {
	const header = useHeader()
	const sharedNavItems = header.navitems // Nav items from Home page

	if (navitems) {
		if (blankHeader) {
			// return <HeaderBlank sharedNavitems={sharedNavItems} navitems={navitems} />
			return <HeaderTransparent type='blank' sharedNavitems={sharedNavItems} navitems={navitems} />
		} else if (transparent) {
			return <HeaderTransparent type='transparent' sharedNavitems={sharedNavItems} navitems={navitems} />
		} else {
			//return <HeaderDefault sharedNavitems={sharedNavItems} navitems={navitems} />
			return <HeaderTransparent type='default' sharedNavitems={sharedNavItems} navitems={navitems} />
		}
	} else {
		return null
	}
}

Header.propTypes = {
	siteTitle: PropTypes.string,
	bgPrimary: PropTypes.bool
}

Header.defaultProps = {
	siteTitle: ``,
	bgPrimary: false,
	transparent: false
}

export default Header
